import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { AlertTriangle, ArrowRight, RefreshCw, Loader2, Mic } from "lucide-react";
import { useRecording, mmss } from "../lib/recording";
import { listPendingAudio } from "../lib/audioStore";
import { formatDateSafe } from "../lib/formatDate";

const PendingAudioDashboardCard = () => {
  const { pendingVersion, retryPending, transcribing } = useRecording();
  const [items, setItems] = useState([]);
  useEffect(() => { listPendingAudio().then((l) => setItems([...l].sort((a, b) => b.savedAt - a.savedAt))).catch(() => setItems([])); }, [pendingVersion]);
  if (items.length === 0) return null;
  return (
    <Card className="border-amber-300 bg-amber-50/60 dark:bg-amber-950/20" data-testid="pending-audio-dashboard-card">
      <CardHeader className="p-4 sm:p-6 pb-2 sm:pb-2">
        <CardTitle className="font-heading text-lg sm:text-xl flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-600" /> {items.length} audio{items.length > 1 ? "s" : ""} non transcrit{items.length > 1 ? "s" : ""} sur cet appareil</CardTitle>
        <p className="text-xs text-muted-foreground" data-testid="pending-audio-dashboard-hint">Enregistrements de séance conservés dans ce navigateur après un échec de transcription. Relancez-les depuis ici ou depuis la séance.</p>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0 sm:pt-0 space-y-2">
        {items.map((it) => {
          const busy = transcribing === it.reportId;
          return (
            <div key={it.reportId} className="flex flex-col sm:flex-row sm:items-center gap-2 rounded-lg border bg-background px-3 py-2" data-testid={`pending-audio-row-${it.reportId}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate flex items-center gap-1.5"><Mic className="w-3.5 h-3.5 text-rose-500 shrink-0" /> {it.meta?.label || "Séance"}</p>
                <p className="text-xs text-muted-foreground">Enregistré le {formatDateSafe(new Date(it.savedAt).toISOString(), { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })} · {(it.size / 1048576).toFixed(1)} Mo{it.meta?.durationSec ? ` · ${mmss(it.meta.durationSec)}` : ""}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <Button size="sm" variant="outline" onClick={() => retryPending(it.reportId)} disabled={!!transcribing} className="gap-1.5" data-testid={`pending-audio-dashboard-retry-${it.reportId}`}>{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} {busy ? "Transcription…" : "Relancer"}</Button>
                {it.meta?.patientId && (
                  <Button size="sm" asChild className="gap-1.5" data-testid={`pending-audio-dashboard-open-${it.reportId}`}>
                    <Link to={`/therapist/patients/${it.meta.patientId}?session=${it.reportId}&tab=transcript`}>Ouvrir la séance <ArrowRight className="w-3.5 h-3.5" /></Link>
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default PendingAudioDashboardCard;
